<div class="cashier-copyright text-center h-20 leading-[80px] mt-20">
  <span class="text-[11px] font-normal">© Copyright by AGF Security Agency 2024</span>
</div>